var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountNavAddContractsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: 24,
    stroke: "none",
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3679 20.229V3.77182C13.3679 3.0144 12.7538 2.40039 11.9964 2.40039C11.239 2.40039 10.625 3.0144 10.625 3.77182V20.229C10.625 20.9864 11.239 21.6004 11.9964 21.6004C12.7538 21.6004 13.3679 20.9864 13.3679 20.229Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76987 13.3718H20.227C20.9844 13.3718 21.5984 12.7578 21.5984 12.0003C21.5984 11.2429 20.9844 10.6289 20.227 10.6289H3.76987C3.01245 10.6289 2.39844 11.2429 2.39844 12.0003C2.39844 12.7578 3.01245 13.3718 3.76987 13.3718Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNavAddContractsIcon);
export default __webpack_public_path__ + "static/media/AccountNavAddContractsIcon.9d0221871531a663e525a5bb56714255.svg";
export { ForwardRef as ReactComponent };